<div class="header">
  <h3>{{'RD-SEND-REPORT.TITLE' | translate}}</h3>
</div>

<div class="box-filter">
  <app-filter-header [loading]="loading" (search)="searchButtonClicked()" (clear)="clearData()"></app-filter-header>
  <div class="row row-eq-height">
    <div class="col-md-4">

      <div class="dropdown-label-group">
        <p-dropdown class="dv-dropdown" selectId="company" [options]="company" [(ngModel)]="selectedCompany"
                    (onChange)="filterBranchList()" [autoDisplayFirst]="false"
                    placeholder="{{'FILTER.COMPANY' | translate}}"
                    [style]="{'z-index': 3}">
        </p-dropdown>
        <label for="company">{{'FILTER.COMPANY' | translate}}</label>
      </div>

      <div class="row m-t-10">
        <div class="col-6">
          <div class="dropdown-label-group">
            <p-dropdown class="dv-dropdown" selectId="month" [options]="monthListDropdown" [(ngModel)]="selectedMonth"
                        [autoDisplayFirst]="false" placeholder="{{'FILTER.MONTH' | translate}}">
            </p-dropdown>
            <label for="month">{{'FILTER.MONTH' | translate}}</label>
          </div>
        </div>

        <div class="col-6">
          <div class="dropdown-label-group">
            <p-dropdown class="dv-dropdown" selectId="year" [options]="yearList" [(ngModel)]="selectedYear"
                        [autoDisplayFirst]="false" placeholder="{{'FILTER.YEAR' | translate}}">
            </p-dropdown>
            <label for="year">{{'FILTER.YEAR' | translate}}</label>
          </div>
        </div>
      </div>

    </div>

    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown class="dv-dropdown" selectId="companyBranch" [options]="branchList" [(ngModel)]="selectedBranch"
                    [autoDisplayFirst]="false" placeholder="{{'FILTER.BRANCH' | translate}}" [style]="{'z-index': 4}">
        </p-dropdown>
        <label for="companyBranch">{{'FILTER.BRANCH' | translate}}</label>
      </div>

      <div class="dropdown-label-group m-t-10">
        <p-dropdown class="dv-dropdown"
                    selectId="rdStatus"
                    [options]="rdStatusDropdown"
                    [(ngModel)]="selectedStatus"
                    [autoDisplayFirst]="false"
                    placeholder="{{'FILTER.STATUS' | translate}}">
        </p-dropdown>
        <label for="rdStatus">{{'FILTER.STATUS' | translate}}</label>
      </div>
    </div>

    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown class="dv-dropdown" selectId="documentType" [options]="rdDocumentType"
                    [(ngModel)]="selectedRdDocumentType" [autoDisplayFirst]="false"
                    placeholder="{{'FILTER.DOCUMENT-TYPE' | translate}}">
        </p-dropdown>
        <label for="documentType">{{'FILTER.DOCUMENT-TYPE' | translate}}</label>
      </div>
    </div>
  </div>
  <span *ngIf="errorMsg" style="color: #e74c3c;margin-right:10px">{{errorMsg}}</span>
</div>

<div class="row">
  <div class="col">
    <div class="text-center box-middle">
      <div class="count-box">
        <strong>{{'RD-SEND-REPORT.NUMBER-OF-DOCUMENTS' | translate }}</strong>
      </div>
      <span class="number mt-2">{{ (totalItems || 0) | number }}</span>
    </div>
  </div>

  <div class="col">
    <div class="text-center box-middle">
      <div class="count-box">
        <strong>{{ 'RD-SEND-REPORT.SENT-TO-SP' | translate }}</strong>
      </div>
      <span class="number mt-2">{{ (statistic && statistic.sent_to_service_provider || 0) | number }}</span>
    </div>
  </div>

  <div class="col">
    <div class="text-center box-middle">
      <div class="count-box">
        <strong>{{ 'RD-SEND-REPORT.RD-ACKNOWLEDGED' | translate }}</strong>
      </div>
      <span class="number mt-2">{{ (statistic && statistic.rd_acknowledged || 0) | number }}</span>
    </div>
  </div>

  <div class="col">
    <div class="text-center box-middle">
      <div class="count-box mb-0">
        <strong>{{ 'RD-SEND-REPORT.RESULT.STATUS' | translate }}</strong>
      </div>

      <div class="row mt-2">
        <div class="col pr-2 pl-4">
          <div class="tag status-filter success" style="padding-top: 7px;">
            <strong class="small-number">{{ (statistic && statistic.rd_accepted || 0) | number }}</strong>
            <br>
            <strong class="description">{{ 'RD-SEND-REPORT.RESULT.ACCEPTED' | translate }}</strong>
          </div>
        </div>
        <div class="col pl-2 pr-2">
          <div class="tag status-filter danger" style="padding-top: 7px;">
            <strong class="small-number">{{ (statistic && statistic.rd_rejected || 0) | number }}</strong>
            <br>
            <strong class="description">{{ 'RD-SEND-REPORT.RESULT.REJECTED' | translate }}</strong>
          </div>
        </div>

        <div class="col pr-4 pl-2">
          <div class="tag status-filter pending-orange" style="padding-top: 7px;">
            <strong class="small-number">
              {{ (statistic && (
              statistic.sent_to_service_provider - statistic.rd_rejected - statistic.rd_accepted - statistic.rd_error
            ) || 0) | number }}
            </strong>
            <br>
            <strong class="description">{{ 'RD-SEND-REPORT.RESULT.PENDING' | translate }}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="box-parent">
  <app-custom-pagination [(currentPage)]="currentPage" [(itemsPerPage)]="itemsPerPage" [totalItems]="totalItems"
                         [maxSize]="5" (pageChange)="pageChanged()" (optionChange)="searchButtonClicked()"
                         *ngIf="no_data === false">
    <button type="button" class="btn btn-dv btn-wide"
            (click)="getExportExcel()">
      {{ 'COMMON.DOWNLOAD' | translate }} Excel
    </button>
  </app-custom-pagination>

  <div class="row m-t-20" *ngIf="no_data === true && loading === false">
    <div class="col-12 text-center">
      <h5>{{'COMMON.DATA-NOT-FOUND' | translate}}</h5>
    </div>
  </div>

  <div class="m-t-20 text-center scrollable">
    <p-table #tt tableStyleClass="table" *ngIf="no_data === false" [loading]="loading"
             [columns]="tableCol" [value]="tableDataDisplay" [customSort]="true" (onSort)="sort($event)"
             [autoLayout]="true">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col">{{'COMMON.TABLE.ORDER' | translate}}</th>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" (click)="pageChanged()">
            {{col.header}}
          </th>
          <th scope="col"> {{'RD-SEND-REPORT.NOTES' | translate}}
          </th>
          <th scope="col">
            <p-checkbox class="dv-checkbox" (onChange)="selectDeselectAll($event)" binary="true" [ngModel]="allChecked"> </p-checkbox>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td>{{index + 1 + ((currentPage - 1) * itemsPerPage)}}</td>
          <td>{{data.corporate_branch_display}}</td>
          <td>{{(currentLang === 'en' ? data.rd_document_type_display : data.rd_document_type_display_th)}}</td>
          <td>{{data.header_invoice_number}}</td>
          <td>{{data.header_issue_dt | date:'dd/MM/yyyy':'UTC'}}</td>
          <td>{{data.ebxml_created_at | date:'dd/MM/yyyy'}}</td>
          <td>{{data.ebxml_conversation_id}}</td>
          <td>
            <i *ngIf="data.ebxml_steps.sent_to_rd" class="fa fa-check-circle text-success"></i>
            <i *ngIf="data.ebxml_steps.sent_to_rd === false" class="fa fa-times-circle text-danger"></i>
          </td>
          <td>
            <i *ngIf="data.ebxml_steps.rd_acknowledged" class="fa fa-check-circle text-success"></i>
            <i *ngIf="data.ebxml_steps.rd_acknowledged === false" class="fa fa-times-circle text-danger"></i>
          </td>
          <td>
            <div class="tag pointer" [class.success]="(data.ebxml_status === 'rd_accepted')"
                 [class.danger]="['rd_rejected', 'failed', 'rd_error'].includes(data.ebxml_status)"
                 [class.pending-orange]="['sent_to_service_provider', 'rd_acknowledged'].includes(data.ebxml_status)"
                 [disablePopover]="!data.ebxml_response" container="body" placement="left"
                 [ngbPopover]="data.ebxml_response" popoverTitle="Detail">
              {{ (data.ebxml_status === 'rd_accepted' ? 'RD-SEND-REPORT.RESULT.ACCEPTED' :
              data.ebxml_status === 'rd_rejected' ? 'RD-SEND-REPORT.RESULT.REJECTED' :
                ['rd_error', 'failed'].includes(data.ebxml_status) ? 'RD-SEND-REPORT.RESULT.ERROR' :
                  'RD-SEND-REPORT.RESULT.PENDING') | translate }}
            </div>
          </td>
          <!--          NOTES column-->
          <td>
            <div class="tag pointer text-dark" *ngIf="data.resend_logs.length > 0" #pop="ngbPopover"
                 (clickOutside)="pop.close()" [disablePopover]="data.resend_logs.length == 0" container="body"
                 placement="left" [ngbPopover]="popOver" popoverTitle="{{ 'RD-SEND-REPORT.DETAIL' | translate }}">
              <i class="fa fa-eye" aria-hidden="true"></i>
            </div>
            <ng-template #popOver>
              <div *ngFor="let log of data.resend_logs; let i = index;">
                <div>
                  {{ 'RD-SEND-REPORT.RESEND-NTH' | translate }} {{ i + 1 }} :
                  {{ log.time }} {{ (log.status === "rd_rejected" ? 'RD-SEND-REPORT.RESULT.REJECTED' :
                  log.status === "sent_to_service_provider" ? 'RD-SEND-REPORT.RESULT.PENDING' :
                    ['rd_error', 'failed'].includes(log.status) ? 'RD-SEND-REPORT.RESULT.ERROR' :
                      log.status === "rd_accepted" ? 'RD-SEND-REPORT.RESULT.ACCEPTED' :
                        "-") | translate }}
                </div>
              </div>
            </ng-template>
          </td>
          <td style="text-align: center">
            <p-checkbox class="dv-checkbox" binary="true" [(ngModel)]="selectedValues[index]" (ngModelChange)="isAllSelect()"></p-checkbox>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-body">
    <h4 class="modal-title" id="modal-basic-title">{{'RD-SEND-REPORT.RESEND-ALL' | translate}}</h4>
    <div class="row" style="margin-bottom: 10px">
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <span style="color: #4d5f7a">{{resendAllPendingMessage}}</span>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-dv btn-danger btn-wide"
            (click)="closeResendAllPending()">{{'COMMON.CLOSE' | translate}}</button>
  </div>
</ng-template>



// WEBPACK FOOTER //
// /opt/app/src/app/features/rd-send-report/rd-send-report.component.html